module["exports"] = [
  "Västra",
  "Östra",
  "Norra",
  "Södra",
  "Övre",
  "Undre"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/street_prefix.js
// module id = 1548
// module chunks = 1